import {t} from "../../i18n";
import {bindInputListeners, showValidationErrors} from "../../utils/formHelpers";

export default function authLogin({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render() {
        const email = sharedState.email;
        const emailWrapped = `<i id="authLoginEmail">${email}</i>`;
        const $el = $(`
    <div class="booking-login-row active" data-auth-step="booking-login">
        <button class='auth-back-btn login-close-button' data-step="booking-init">&times;</button>
        <form class="booking-login-form">
            <h3>${t('welcome_back_to_your_account')}</h3>
            <p>${t('auth.enter_your_password_for_email', {email: emailWrapped})}</p>
            <div class="form-row">
                <label for="bookingLoginPassword">${t('password')}</label>
                <input id="bookingLoginPassword"
                       type="password" name="password" required 
                       placeholder="${t('type_in_your_password')}"/>
                <p class="field-error field-password-length-error" style="display:none;">${t('password_must_have_at_least_6_characters')}</p>
            </div>
            <div class="form-actions">
                <p class="field-error field-credentials-incorrect-error" style="display:none;">${t('password_incorrect')}</p>
                <button type="button" class="booking-login-forgot-password-button">
                    ${t('forgot_your_password')}
                </button>
                <button type="submit">${t('login')}</button>
            </div>
        </form>
    </div>
        `);

        $el.find('.booking-login-forgot-password-button').on('click', () => {
            onNext('booking-login-alt', { email });
        });

        $el.on('submit', '.booking-login-form', e => {
            e.preventDefault();

            const password = $el.find('#bookingLoginPassword').val();

            api.post(routes.webLogin, {
                data: {
                    email: sharedState.email,
                    password: password,
                },
                success: (data) => {
                    const user = data.hasOwnProperty('user') ? data.user : data; // legacy compatibility
                    if (user.phone_check === 0) {
                        sharedState.phone = user.phone;
                        onNext('booking-phone')
                    } else {
                        onComplete({user: user, fullData: data});
                    }
                },
                error: (err) => {
                    console.warn('Failed:', err);
                    showValidationErrors($el, err.data.errors || {});
                }
            })
        });

        // After rendering the DOM:
        bindInputListeners($el);

        return $el;
    }

    return { render };
}